import { Field, Form, Formik, useFormikContext } from "formik";
import "./add-edit-smr-agreement-form.css";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { observer } from "mobx-react";
import LoaderButton from "../../../shared-components/button/loader-button";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import { addSalesAgreementRecordValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import noImage from "../../../assets/Images/body-bg.jpg";
import FormikReactQuill from "../../../shared-components/FormikFormHandlers/FormikFormReactQuill";
import { useEffect, useState } from "react";
import { SMRTabEnum } from "../../../constants/enums/smr-tab-enum";
import { useStore } from "../../../contexts/store-provider";
import { IOption } from "../../../models/ICommon";
import AgreementSignPopupHOC from "../hoc/agreement-sign-popup-hoc";
import AgreementSignForm from "./agreement-sign-form";
import SignImageUploader from "./sign-image-uploader";
import {
  IAddAgreementRecord,
  IAddMedicalImages,
  IsAgreementImages,
  ISignStateProps,
} from "../../../models/response/ISMRResponse";
import { formatMessage } from "../../../translations/format-message";
import { generatePDF } from "../../../constants/constants";
import Preview from "../components/Image/edit-preview-image/preview";
import ImageCardDnD from "../components/Image/agreement-image-card";
import { ImageTypeEnum } from "../../../constants/enums/image-type-enum";
interface IProps {
  isOpen: boolean;
  viewOnly: boolean;
  toggleHistory: () => void;
  submitHandler: (values: IAddAgreementRecord) => void;
  showAgreementSignPopup: boolean;
  agreementSignPopupToggleHandler: () => void;
}

const AddEditSMRAgreementForm = (props: IProps) => {
  const { smrStore, agreementManagementStore } = useStore();
  const {
    activeTab,
    salesAgreementRecordDetail,
    selectedBookingId,
    setAgreementImageUploader,
    addUpdateSaleAgreementRecordState,
    isNavigationPasswordNotSetForAgreement,
  } = smrStore;
  const {
    GetAllAgreementOptionService,
    getAllAgreementOptions,
    resetagreementOptionsState,
    allAgreements,
  } = agreementManagementStore;

  const [uploadedSign, setUploadAgreementImages] = useState<IsAgreementImages>({
    Images: [],
    IsUploaded: false,
  });
  const [canvaSign, setCanvaSign] = useState<ISignStateProps>({
    Sign: "",
    IsSignUploaded: false,
  });
  const [selectedAgreement, setSelectedAgreement] = useState<number>(
    salesAgreementRecordDetail.AgreementId
  );
  const [showPreview, setShowPreview] = useState(false);
  const [selectedImage, setSelectedImage] = useState<number>(-1);
  const [isAddCase, setIsAddCase] = useState<boolean>(false);
  
  //   const [isAgreementChanged, setisAgreementChnaged] = useState<boolean>(false);

  useEffect(() => {
    if (activeTab === SMRTabEnum.Agreement) {
      GetAllAgreementOptionService();
    }
  }, [activeTab, selectedBookingId]);

  const FormObserver: React.FC = () => {
    const { values, setFieldValue } = useFormikContext<any>();

    useEffect(() => {
      if (values.AgreementId > 0) {
        if (selectedAgreement !== parseInt(values.AgreementId)) {
          setCanvaSign({ Sign: "", IsSignUploaded: false });
          setUploadAgreementImages({ Images: [], IsUploaded: false });
          //   setisAgreementChnaged(true);
        }
        let agreementDetails = getAllAgreementOptions.filter(
          (agreement: IOption) => agreement.id == values.AgreementId
        );
        if (agreementDetails.length > 0)
          setFieldValue(
            "Agreement",
            agreementDetails[0]?.data ? agreementDetails[0].data?.Content : ""
          );
        setSelectedAgreement(parseInt(values.AgreementId));
      }
    }, [values.AgreementId]);
    return null;
  };

  useEffect(() => {
    if (addUpdateSaleAgreementRecordState.success) {
      setCanvaSign({ Sign: "", IsSignUploaded: false });
      setUploadAgreementImages({ Images: [], IsUploaded: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateSaleAgreementRecordState.success]);

  useEffect(() => {
    if (selectedBookingId > 0) {
      //   setisAgreementChnaged(false);
      setUploadAgreementImages({ Images: [], IsUploaded: false });
      setCanvaSign({ Sign: "", IsSignUploaded: false });
      setSelectedAgreement(-1);
    }
  }, [selectedBookingId]);

  const signClearHandler = () => {
    setUploadAgreementImages({ Images: [], IsUploaded: false });
    setCanvaSign({ Sign: "", IsSignUploaded: false });
  };

  const handleRemoveImage = (index: number) => {
    setUploadAgreementImages((prev) => {
      let { Images } = prev;
      let tempImages = Images.filter((_, i) => i !== index);
      return { Images: tempImages, IsUploaded: tempImages.length > 0 };
    });
  };

  const handleShowPreview = (index: number) => {
    setSelectedImage(index)
    setShowPreview(true);
  };

  const onModalClosed = () => {
    setShowPreview(false);
    setSelectedImage(-1);
    setIsAddCase(false);
  };

  return (
    <>
      {showPreview && (
        <Preview
          image={!isAddCase ? 
            (salesAgreementRecordDetail.AgreementImages ? salesAgreementRecordDetail.AgreementImages[selectedImage]?.ImageBase64 || "" : "") :
            (uploadedSign.Images ? uploadedSign.Images[selectedImage]?.ImageBase64 || "" : "")
          }
          onModalClosed={onModalClosed}
        />
      )}
      <Formik
        initialValues={salesAgreementRecordDetail}
        enableReinitialize
        validationSchema={
          uploadedSign.Images.length === 0
            ? addSalesAgreementRecordValidationSchema
            : undefined
        }
        onSubmit={(values) => {
          let data: IAddAgreementRecord = {
            SMRId: selectedBookingId,
            AgreementSignOffDate: values.AgreementSignOffDate,
            AgreementId: canvaSign.Sign ? values.AgreementId : null,
            Agreement: canvaSign.Sign ? values.Agreement : null,
            Image: canvaSign.IsSignUploaded ? canvaSign.Sign : null,
            IsSigned: true,
            AgreementImages:
              uploadedSign.Images.length > 0 ? uploadedSign.Images : null,
          };
          props.submitHandler(data);
        }}
      >
        {({ values, setFieldError, setFieldValue }) => (
          <>
            {props.showAgreementSignPopup && (
              <AgreementSignForm
                agreementContent={values.Agreement}
                submitHandler={(signDetails: any) => {
                  let data: IAddAgreementRecord = {
                    SMRId: selectedBookingId,
                    AgreementSignOffDate: values.AgreementSignOffDate,
                    AgreementId: values.AgreementId,
                    Agreement: values.Agreement,
                    Image: signDetails,
                    IsSigned: true,
                    AgreementImages: null,
                  };
                  props.submitHandler(data);
                  // setCanvaSign((prev) => {
                  //   return { ...prev, Sign: values, IsSignUploaded: true };
                  // });
                }}
                modalClosed={props.agreementSignPopupToggleHandler}
              />
            )}
            <Form>
              {
                salesAgreementRecordDetail.Id < 0 &&
                <FormObserver />
              }
              {/* <FormObserver /> */}
              <div className="d-flex  align-items-start mb-3">
                <div className="w-25 me-2">
                  <Field
                    className="form-select"
                    name="AgreementId"
                    options={getAllAgreementOptions}
                    as={FormikFormSelect}
                    disabled={
                      props.viewOnly
                        ? props.viewOnly
                        : salesAgreementRecordDetail.Id > 0
                    }
                  />
                </div>
                <SignImageUploader
                  setUploadAgreementImages={setUploadAgreementImages}
                  setCanvaSign={setCanvaSign}
                  selectedImages={uploadedSign.Images}
                  setAgreementImageUploader={setAgreementImageUploader}
                  setFieldError={setFieldError}
                  setFieldValue={setFieldValue}
                  disabled={
                    props.viewOnly
                      ? props.viewOnly
                      : salesAgreementRecordDetail.Id > 0
                  }
                />
                <button
                  className="btn btn-link ms-2"
                  type="button"
                  onClick={props.toggleHistory}
                >
                  <i className="bi bi-cloud-upload-fill"></i>{" "}
                  <span>
                    {formatMessage(
                      !props.isOpen
                        ? "view_past_agreements"
                        : "close_past_agreements"
                    )}
                  </span>
                </button>
              </div>

              <div
                className={`row ${
                  props.isOpen
                    ? "agreementSidebar-close"
                    : "agreementSidebar-open"
                }`}
              >
                <div>
                  <h3 className="mb-2">
                    {formatMessage("agreement")}
                    {salesAgreementRecordDetail.Id > 0 &&
                    salesAgreementRecordDetail.AgreementImages &&
                    salesAgreementRecordDetail.AgreementImages?.length > 0 && (
                    <button
                      className="btn btn-primary ms-2"
                      type="button"
                      onClick={() =>
                        generatePDF(salesAgreementRecordDetail)
                      }
                    >
                      <i className="bi bi-download me-2"></i>
                      <FormattedMessage id="download" />{" "}
                      <FormattedMessage id="agreement" />
                    </button>
                    )}
                  </h3>
                  <div className="border">
                    {salesAgreementRecordDetail.Id > 0 &&
                    salesAgreementRecordDetail.AgreementImages &&
                    salesAgreementRecordDetail.AgreementImages?.length > 0 ? (
                      <div className="text-center">
                        <div className="agreement_image_container">
                          <div className="thumbnail-container">
                            {salesAgreementRecordDetail.AgreementImages.map(  
                              (img: IAddMedicalImages, index: number) => (
                                <div className="thumbnail-wrapper">
                                  <ImageCardDnD
                                    className="thumbnail-wrapper"
                                    type={"Before"}
                                    key={index}
                                    id={index?.toString()}
                                    index={index}
                                    viewOnly={false}
                                    imageType={ImageTypeEnum.AgreementImage}
                                    images={salesAgreementRecordDetail.AgreementImages ? salesAgreementRecordDetail.AgreementImages.map((img)=> {return img.ThumbnailImage}) : []}
                                    handleDeleteImage={undefined}
                                    handleShowPreview={() => {
                                      setIsAddCase(false)
                                      handleShowPreview(index)
                                    }}
                                  />
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    ) : values.AgreementId === -1 &&
                      uploadedSign.Images.length > 0 ? (
                      <>
                        {uploadedSign.Images.length > 0 && (
                          <div className="thumbnail-container">
                            {uploadedSign.Images.map((img, idx) => (
                              <div key={idx} className="thumbnail-wrapper">
                                <div className="thumbnail-wrapper">
                                  <ImageCardDnD
                                    className="thumbnail-wrapper"
                                    type={"Before"}
                                    key={idx}
                                    id={idx?.toString()}
                                    index={idx}
                                    viewOnly={false}
                                    imageType={ImageTypeEnum.AgreementImage}
                                    images={uploadedSign.Images ? uploadedSign.Images.map((img)=> {return img.ThumbnailImage}) : []}
                                    handleDeleteImage={()=> handleRemoveImage(idx)}
                                    handleShowPreview={() => {handleShowPreview(idx)
                                      setIsAddCase(true);
                                    }}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <div className="agreement_textarea">
                          <Field
                            type="text"
                            name="Agreement"
                            as={FormikReactQuill}
                            disabled={true}
                          />
                        </div>
                        {/* Signature Section */}
                        <div className="border-top p-3">
                          <h3 className="mb-0">{formatMessage("signature")}</h3>
                          <div className="py-3">
                            {!canvaSign.IsSignUploaded && (
                              <img
                                src={
                                  salesAgreementRecordDetail.Image
                                    ? salesAgreementRecordDetail.Image
                                    : noImage
                                }
                                alt="Signature"
                                className="signature_img"
                              />
                            )}
                            {canvaSign.IsSignUploaded && (
                              <img
                                src={
                                  canvaSign.IsSignUploaded
                                    ? canvaSign.Sign
                                    : noImage
                                }
                                alt="Signature"
                                className="signature_img"
                              />
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {/* Buttons */}
                  <div className="d-flex justify-content-center mt-3 gap-2">
                    <LoaderButton
                      type="submit"
                      iconName="bi-check-lg"
                      isLoading=""
                      disabled={
                        props.viewOnly
                          ? props.viewOnly
                          : !(
                              uploadedSign.IsUploaded ||
                              canvaSign.IsSignUploaded
                            ) || salesAgreementRecordDetail.Id > 0
                      }
                      text="button_update"
                    />
                    {values.AgreementId === -1 ? (
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={
                          props.viewOnly
                            ? props.viewOnly
                            : isNavigationPasswordNotSetForAgreement
                            ? true
                            : uploadedSign.IsUploaded ||
                              canvaSign.IsSignUploaded ||
                              salesAgreementRecordDetail.Id > 0
                        }
                      >
                        <i className="bi bi-pencil-square me-1"></i>
                        <FormattedMessage id="sign" />
                      </Button>
                    ) : (
                      <Button
                        variant="primary"
                        type="button"
                        disabled={
                          props.viewOnly
                            ? props.viewOnly
                            : isNavigationPasswordNotSetForAgreement
                            ? true
                            : uploadedSign.IsUploaded ||
                              canvaSign.IsSignUploaded ||
                              salesAgreementRecordDetail.Id > 0
                        }
                        onClick={props.agreementSignPopupToggleHandler}
                      >
                        <i className="bi bi-pencil-square me-1"></i>
                        <FormattedMessage id="sign" />
                      </Button>
                    )}
                    {salesAgreementRecordDetail.Id === -1 &&
                      !props.viewOnly && (
                        <Button
                          variant="outline-danger"
                          type="button"
                          disabled={
                            !(
                              uploadedSign.IsUploaded ||
                              canvaSign.IsSignUploaded
                            ) || salesAgreementRecordDetail.Id > 0
                          }
                          onClick={signClearHandler}
                        >
                          <i className="bi bi-x-lg me-1"></i>
                          <FormattedMessage id="delete" />
                        </Button>
                      )}
                  </div>
                  {(salesAgreementRecordDetail.Id < 0 && (isNavigationPasswordNotSetForAgreement && !(values.AgreementId === -1 &&
                      uploadedSign.Images.length > 0))) && (
                      <div className="alert alert-danger w-50 mx-auto text-center mt-3">
                        <FormattedMessage id="PasswordNotSet" />
                      </div>
                    )}
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default AgreementSignPopupHOC(observer(AddEditSMRAgreementForm));
